<div [ngClass]="type === 'donut' ? 'parent-donutChart' : 'parent-barChart'">
    <ag-charts-angular 
    [ngClass]="type === 'donut' ? 'donutChart' : 'barChart'"
    [options]="options">
    </ag-charts-angular>
    <div class="custom-legend">
        @if(info.title === "Rate Agreement"){
            <div class="active">
                <div style="font-size: 10px;"><div class="dot" style="background-color: #6D6D6D;"></div> Active {{getPercentage(this.info, 'active')}}%</div>
                <span style="font-size: 10px;margin-left: 20px;">{{getCount(this.info.data, 'active')}} Agreements</span>
            </div>
            <div class="draft">
                <div style="font-size: 10px;"><span class="dot" [ngStyle]="{'background-color':appService.selectedTheme?'#D40511':'#2196f3'}"></span>Draft {{getPercentage(this.info, 'draft')}}%</div>
                <span style="font-size: 10px;margin-left: 20px;">{{getCount(this.info.data, 'draft')}} Agreements</span>
            </div>
        }
        @else if(info.title === "Due Rate Agreement"){
            <div class="active">
                <div style="font-size: 10px;"><div class="dot" style="background-color: #6D6D6D;"></div> Due for auto extension {{getPercentage(this.info, 'active')}}%</div>
                <span style="font-size: 10px;margin-left: 20px;">{{getCount(this.info.data, 'active')}} Agreements</span>
            </div>
            <div class="draft">
                <div style="font-size: 10px;"><span class="dot" [ngStyle]="{'background-color':appService.selectedTheme?'#D40511':'#2196f3'}"></span>Due for termination {{getPercentage(this.info, 'draft')}}%</div>
                <span style="font-size: 10px;margin-left: 20px;">{{getCount(this.info.data, 'draft')}} Agreements</span>
            </div>
        }
        @else if(info.title === "Draft Rate Agreement"){
            <div class="active">
                <div style="font-size: 10px;"><div class="dot" style="background-color: #6D6D6D;"></div> Draft Manual {{getPercentage(this.info, 'active')}}%</div>
                <span style="font-size: 10px;margin-left: 20px;">{{getCount(this.info.data, 'active')}} Agreements</span>
            </div>
            <div class="draft">
                <div style="font-size: 10px;"><span class="dot" [ngStyle]="{'background-color':appService.selectedTheme?'#D40511':'#2196f3'}"></span>Draft Fuel Escalator {{getPercentage(this.info, 'draft')}}%</div>
                <span style="font-size: 10px;margin-left: 20px;">{{getCount(this.info.data, 'draft')}} Agreements</span>
            </div>
        }
        
        
    </div>
</div>

